import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase/config";
import { auth } from "../firebase/config";
import { doc, updateDoc } from "firebase/firestore";
import { deleteDoc } from "firebase/firestore";
// import { deleteDoc, doc } from "firebase/firestore";

export const getAdminNotifications = async () => {
  const snapshot = await getDocs(collection(db, "adminNotifications"));

  const notifications = snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  return notifications.sort((a, b) => {
    const aTime = a.createdAt?.seconds
      ? a.createdAt.seconds * 1000
      : new Date(a.createdAt || 0).getTime();

    const bTime = b.createdAt?.seconds
      ? b.createdAt.seconds * 1000
      : new Date(b.createdAt || 0).getTime();

    return bTime - aTime;
  });
};

export const getMemberNotifications = async () => {
  const uid = auth.currentUser?.uid;

  const snapshot = await getDocs(
    collection(db, "gyms", uid, "memberNotifications"),
  );

  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
};

export const markEmailSent = async (notificationId) => {
  await updateDoc(doc(db, "adminNotifications", notificationId), {
    emailSent: true,
  });
};

export const deleteNotification = async (notificationId) => {
  await deleteDoc(doc(db, "adminNotifications", notificationId));
};

export const deleteMemberNotification = async (notificationId) => {
  await deleteDoc(
    doc(
      db,
      "gyms",
      auth.currentUser.uid,
      "memberNotifications",
      notificationId,
    ),
  );
};
